import React from 'react';
import './contraindicatedvaccinationsbar.css';
import {VaccineModel} from '../../../../../model/vaccine.model';
import {ExternalLink} from 'lucide-react';

interface ContraindicatedVaccinationsBarProps {
    t: (key: string) => string;
    showResultsForProfessionals: boolean,
    vaccinations: VaccineModel[];
    className?: string;
}

const ContraindicatedVaccinationsBar: React.FC<ContraindicatedVaccinationsBarProps> = ({ t, showResultsForProfessionals, vaccinations }: ContraindicatedVaccinationsBarProps) => {

    return (
        <div className="contraindicated-vaccinations-bar__wrapper">

            <div className="contraindicated-vaccinations-bar__headers-contraindicated__wrapper">
                <div className={showResultsForProfessionals ? "contraindicated-vaccinations-professionals-bar_name__wrapper" : "contraindicated-vaccinations-bar_name__wrapper"}>
                    {t('table_header_name')}
                </div>
                <div className={showResultsForProfessionals ? "contraindicated-vaccinations-professionals-bar_leaflet__wrapper" : "contraindicated-vaccinations-bar_leaflet__wrapper"}>
                    {t('table_header_leaflet')}
                </div>
            </div>

            <div className="contraindicated-vaccinations-bar__inner-wrapper">

                <div className="contraindicated-vaccinations-bar_single-vaccine__wrapper">
                    {vaccinations.map((vaccine) => (

                        <div key={vaccine.abbreviation} className="contraindicated-vaccinations-bar_single-vaccine">

                            <div className={showResultsForProfessionals ? "contraindicated-vaccinations-professionals-bar_name__wrapper" : "contraindicated-vaccinations-bar_name__wrapper"}>
                                {vaccine.fullName}
                            </div>

                            <div className={showResultsForProfessionals ? "contraindicated-vaccinations-professionals-bar_leaflet__wrapper" : "contraindicated-vaccinations-bar_leaflet__wrapper"}>
                                {
                                    vaccine.leaflet.length > 0 &&
                                    <a href={vaccine.leaflet}
                                       target="_blank"
                                       className='contraindicated-vaccinations__link'
                                       rel="noreferrer">
                                        {t('leaflet_link')} <ExternalLink size={12}/>
                                    </a>
                                }
                            </div>

                        </div>
                    ))}
                </div>
            </div>

        </div>
    )

}

export default ContraindicatedVaccinationsBar;
